/**
 * @Description: 下载导出
 */
import { fileDownload } from "@/ask/axios";

/**
 * @export
 * @param {*} url  下载地址  ---接口地址
 * @param {*} fileName  下载的命名
 */
export function downloadFile(url,fileName){
  // apiAir 以/结尾 需要判断url 是否以/开头
  let mb=myBrowser();
  if('IE'==mb){
    getBlob(url).then(blob => {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    });
  }else{
    var request = new XMLHttpRequest();
      request.responseType = "blob";
      request.open("GET",url);
      request.onload = function() {
        var url = window.URL.createObjectURL(this.response);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = url;
        a.download = fileName
        a.click();
      }
      request.send();
  }
}
function getBlob(url){
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      }
    };
    xhr.send();
  });
}
function myBrowser(){
  if(!!window.ActiveXObject || "ActiveXObject"in window){
    return "IE";  // 因为ie10-ie11的版本问题，不再支持document.all判断，所以ie判断函数要重新写了
  }
}


/**
 * @description:下载导出文件流
//  * @param { string } method  请求 api 方法类型
//  * @param { string } url  请求 api 地址, 不用网址，只要路径
 * @param { object } vm this
 * @param { object } params  请求 api 传递的参数
 * @param { string } fileName 导出文件名称, 需要加后缀名
*/
export function fileSteamDownload(vm, params, fileName) {
  fileDownload('get', vm.$api04 + 'File/api/FileHandle/Download', params).then((res) => {
    // 把后台传过来的文件流转化成blob url路径下载
    const hrefUrl = window.URL.createObjectURL(
      new Blob([res.data], {
        type: "application/vnd.opencmlformats-officedocument.spreadsheetml.sheet",
      })
    );
    // 创建一个a标签下载文件
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = hrefUrl;
    // 设置文件名称、后缀名
    link.download = decodeURIComponent(fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // 释放内存
    window.URL.revokeObjectURL(hrefUrl);
  });
}


/**
 * @description: 下载导出base64编码
//  * @param { string } method  请求 api 方法类型
//  * @param { string } url  请求 api 地址
 * @param { object } vm this
 * @param { object } params  请求 api 传递的参数
 * @param { string } fileName 导出文件名称, 需要加后缀名
*/
export function downloadFileSteam(vm, params, fileName) {
  return new Promise(async (resolve, reject) => {
    let url = '';
    await fileDownload('get', vm.$api04 + 'File/api/FileHandle/Download', params).then((res) => {
      // 把后台传过来的文件流转化成blob url路径下载
      let blob = new Blob([res.data])
      // );
      // 创建一个a标签下载文件
      let oFileReader = new FileReader();
      oFileReader.onloadend = function(e) {
      // 结果
      console.log(e.target.result);
        url = e.target.result
        resolve(url);
      };
      oFileReader.readAsDataURL(blob);
      return false;
      // 释放内存
      // window.URL.revokeObjectURL(hrefUrl);
      
    });
    
  });
 
  
  
}



// WEBPACK FOOTER //
// ./src/util/download.js